import spartaEventsUtility from "global/sparta-events-utility";
import spartaGlobalFunctions from "global/sparta-global-functions-utility";
import spartaStoreUtility from "global/sparta-store-utility";
import Handlebars from "vendor/handlebars";
import hbs from "vendor/handlebars";
import jQuery from "vendor/jquery";
import $ from "vendor/jquery";
import spartaBootstrapUtility from "global/sparta-bootstrap-utility";
import spartaTransportUtility from "global/sparta-transport-utility";
import spartaMessageUtility from "global/sparta-messaging-utility";
import spartaRequireUtility from "global/sparta-require-utility";
import moduleContainer from "helpers/module-container";
import Communicator from "utilities/global/sparta-module-utility/3.5.0/js/communicator";
import Controller from "utilities/global/sparta-module-utility/3.5.0/js/controller";
import Model from "utilities/global/sparta-module-utility/3.5.0/js/model";
import View from "utilities/global/sparta-module-utility/3.5.0/js/view";

moduleContainer.register(Handlebars);






function loadOnDemandHelpers(helpers) {
  return Promise.all(helpers.map((helper) => spartaRequireUtility.getRequirePromise([helper]))).then((helperExports) => {
    helperExports.forEach((helperExport) => helperExport.register(Handlebars));
  });
}







const getTemplatesPath = (ref, version) => `modules/${ref}/${version}/js/templates`;







function getCompleteModuleInfo(moduleObj, onDemandModules) {
  const modules = onDemandModules.modules[moduleObj.module];

  if (!modules) throw new Error(`Couldn't find the on-demand module ${moduleObj.module}.`);





  const moduleInfo = _.cloneDeep(modules.find(obj => obj.version === moduleObj.version) || modules[0]);


  moduleInfo.context = moduleInfo.context || {};


  moduleObj.context = moduleObj.context || {};


  Object.assign(moduleInfo.context.params, moduleObj.context.params, moduleInfo.context.config);

  return {
    moduleRef: moduleObj.module, 
    ...moduleInfo
  };
}




























function resolveModuleDataSources(customDataSources, defaultDataSources) {
  return new Promise((resolve, reject) => {
    const resolvedDataSources = Object.assign({}, defaultDataSources);
    const dataSourcePromises = [];

    _.each(customDataSources, (dataSource, key) => {
      if (typeof dataSource === 'string' || dataSource instanceof String) {
        dataSourcePromises.push(new Promise((resolve, reject) => {
          spartaTransportUtility.subscribe({
            cache: true,
            dataType: 'json',
            success: data => {
              resolvedDataSources[key] = data;
              resolve();
            },
            error: error => {


              resolve();
            },
            url: dataSource
          });
        }));
      }
      else {
        resolvedDataSources[key] = dataSource;
      }
    });

    Promise.all(dataSourcePromises).then(() => resolve(mapDataSourcesByLanguage(resolvedDataSources)));
  });
}

































function mapDataSourcesByLanguage(dataSources) {
  const mappedDataSources = {};

  _.each(dataSources, (dataSource, key) => {
    const source = {};
    source[window.sparta.language] = dataSource;

    mappedDataSources[key] = source;
  });

    return mappedDataSources;
}







function getModuleTemplate(module, version) {
  return spartaRequireUtility.getRequirePromise([getTemplatesPath(module, version)]);
}





function registerModuleTemplates(moduleInit) {
  (moduleInit.default.templates || []).forEach(templateObj => {
    Handlebars.registerPartial(templateObj.name, Handlebars.template(templateObj.precompiled));
  });
}







function getAndRegisterModuleTemplates(moduleRef, version) {
   return getModuleTemplate(moduleRef, version).then(moduleInit => {
     registerModuleTemplates(moduleInit);
   });
}







function getModuleMainJs(mainJs) {
  return spartaRequireUtility.getRequirePromise([mainJs]).catch(e => {
    throw new Error(`Error fetching module ${mainJs}: ${e.message}.`)
  });
}






function getMountElement(target) {
  const element = target instanceof HTMLElement
    ? target
    : document.querySelector(target);

  if (!(element instanceof HTMLElement)) {
    throw new Error(`Target ${target} isn't a valid HTML element or query selector string.`);
  }

  return element;
}

export default class Module {
  constructor(options) {
    let defaults = {
        "target": null,
        "$target": $(),
        "debug": false,
        "events": {
            "namespace": "module"
        }
    },
    required = {};

    this.settings = $.extend(true, {}, defaults, options, required);
    this.settings.target = this.settings.class ? this.settings.class : this.settings.target;
    this.settings.$target = $(this.settings.target);
    this.settings.SPARTA_READY = (this.settings.$target.data('sparta-load') === 'primary') ? 'SPARTA_GLOBAL_READY.spartaBootstrapUtility' : 'SPARTA_SECONDARY_READY.spartaBootstrapUtility';




    for ( data in this.settings.data ) {
      if ( this.settings.$target.data( data ) ) {
        this.settings.data[ data ] = this.settings.$target.data( data );
      }
    }

    this.model = new Model({ settings: this.settings });
    this.view = new View({ model: this.model, settings: this.settings });
    this.controller = new Controller({ model: this.model, settings: this.settings });

    this.Events = spartaEventsUtility;
    this.Store =  spartaStoreUtility;
    this.Transport = spartaTransportUtility;
    this.SpartaFunctions = spartaGlobalFunctions;

    this.Message = spartaMessageUtility;

    this.applicationContext = spartaStoreUtility.getData('applicationContext');
    this.applicationContainer = spartaStoreUtility.getData("applicationContainer");
    this.spaParams = spartaStoreUtility.getData("spaParams");
    this.eventDelegatorString = (this.applicationContext) ? `[data-version="${this.applicationContext.version}"][data-sparta-container="${this.applicationContext.name}"]` : '[data-sparta-container]';
    this.isWidget = !!spartaStoreUtility.getData("isWidget");

    this.params = this.settings.$target.data('module-parameters');


    this.settings.moduleInfo = {
      name: this.settings.$target.data("module"),
      version: this.settings.$target.data("version")
    }


    this.settings.moduleInfo.options = this.Store.getData("applicationOptions")[this.settings.moduleInfo.name];

    const onDemandModules = this.spaParams.onDemandModules || {};
    this.baseHelpersPromise = onDemandModules && onDemandModules.baseHelpers ? 
      loadOnDemandHelpers(onDemandModules.baseHelpers) :
      undefined;


    spartaBootstrapUtility.register(this);
  }
















































  mountAll(modules) {
    if (this.baseHelpersPromise) {
      return this.baseHelpersPromise.then(() => {
        if (Array.isArray(modules)) {    
          return Promise.all(modules.map(this._mount));
        }

        return this._mount(modules);
      });
    }

    return Promise.reject(new Error('No on-demand modules found.'));
  }














  _mount(moduleObj) {
    const { moduleRef, helpers, mainJs, version, context } = getCompleteModuleInfo(moduleObj, this.spaParams.onDemandModules);

    return Promise.all([
      resolveModuleDataSources(moduleObj.context.dataSources, context.dataSources).then((dataSources) => {
        context.dataSources = dataSources;
      }),
      loadOnDemandHelpers(helpers),
      getAndRegisterModuleTemplates(moduleRef, version),
      getModuleMainJs(mainJs)
    ]).then(values => {
      const element = getMountElement(moduleObj.target);

      element.innerHTML = moduleContainer.helpers.composeModule({
        global: this.spaParams.global,
        params: this.spaParams.siteParams
      }, {
        parameters: this.spaParams.pageParams
      },
      window.sparta.language,
      window.sparta.env,
      undefined,
      context,
      );

      const mainJsInit = values[3];
      spartaBootstrapUtility.createAndInitModules([mainJsInit]);
    });
  }

  _debug(msg) {
    if ( window.console && this.settings.debug ) {
      console.log( msg );
    }
  };
};